package org.moxultimate.topwithmox.components.crud

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.moxultimate.topwithmox.components.buttons.GradientButton
import org.moxultimate.topwithmox.theme.FontFamily

/**
 * Full-screen fixed overlay shown after a successful CRUD operation.
 * Renders a white card with a checkmark, [message], and an "Okay" button.
 *
 * @param message Text to display (e.g. "Successfully updated!").
 * @param onOkay  Called when the user clicks Okay.
 */
@Composable
fun CRUDSuccessDialog(message: String, onOkay: () -> Unit) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .fillMaxHeight()
            .position(Position.Fixed)
            .top(0.px).left(0.px)
            .zIndex(2000)
            .styleModifier { property("background-color", "rgba(0,0,0,0.45)") },
        contentAlignment = Alignment.Center,
    ) {
        Column(
            modifier = Modifier
                .padding(all = 40.px)
                .backgroundColor(Colors.White)
                .borderRadius(20.px)
                .border(1.px, LineStyle.Solid, Colors.LightGray)
                .styleModifier { property("min-width", "360px"); property("max-width", "480px") },
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(24.px),
        ) {
            SpanText(text = "✅", modifier = Modifier.fontSize(48.px))
            SpanText(
                text = message,
                modifier = Modifier
                    .fontFamily(FontFamily)
                    .fontSize(20.px)
                    .fontWeight(FontWeight.Bold)
                    .color(Colors.DarkGreen)
                    .styleModifier { property("text-align", "center") },
            )
            GradientButton(text = "Okay", onClick = onOkay)
        }
    }
}
